import { render, staticRenderFns } from "./AppRecord.vue?vue&type=template&id=4911c1ae&scoped=true&"
import script from "./AppRecord.vue?vue&type=script&lang=js&"
export * from "./AppRecord.vue?vue&type=script&lang=js&"
import style0 from "./AppRecord.vue?vue&type=style&index=0&id=4911c1ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4911c1ae",
  null
  
)

export default component.exports